import React, { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const SpecificationLightbox: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const isMobile = useMediaQuery("(max-width: 600px)");

  const desktopImages = [
    "https://dprstorage.b-cdn.net/kolla/specs/Specs%20new-03.png",
  ];

  const mobileImages = [
    "https://dprstorage.b-cdn.net/kolla/specs/Specs%20new-04.png",
    "https://dprstorage.b-cdn.net/kolla/specs/Specs%20new-05.png",
  ];

  const images = isMobile ? mobileImages : desktopImages;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mt: 0,
        mb: 5,
        zIndex: 1000000,
      }}
    >
      <Box
        sx={{
          width: { xs: "50%", sm: "62%", md: "255px" },
          maxWidth: "260px",
          cursor: "pointer",
          background: "linear-gradient(90deg, #bf742c, #fff8da, #c58038)",
          borderRadius: "12px",
          padding: { xs: "10px", md: "16px" },
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgb(0, 0, 0)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "scale(1.02)",
            boxShadow: "0px 8px 25px rgba(0, 0, 0, 0.3)",
          },
        }}
        onClick={() => setIsOpen(true)}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "600",
            fontSize: { xs: "18px", sm: "22px", md: "26px" },
            color: "black",
            textAlign: "center",
          }}
        >
          Specifications
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "10px", sm: "12px", md: "14px" },
            fontFamily: "LEMON MILK",
            color: "black",
            fontWeight: "400",
            mt: 0.5,
            textDecoration: "none",
            "&:hover": { textDecoration: "underline" },
            textAlign: "center",
          }}
        >
          Tap to View
        </Typography>
      </Box>

      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}
    </Box>
  );
};

export default SpecificationLightbox;
